<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-title-tip :theme="$otTheme" content="HI! 你好" manual clickable>
                <span>请点击我</span>
            </ot-title-tip>
            <ot-title-tip :theme="$otTheme" content="HI! 你好" manual clickable>
                <ot-link>请点击我</ot-link>
            </ot-title-tip>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-title-tip%20content%3D%22HI!%20%E4%BD%A0%E5%A5%BD%22%20manual%20clickable%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E8%AF%B7%E7%82%B9%E5%87%BB%E6%88%91%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-title-tip%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-title-tip%20content%3D%22HI!%20%E4%BD%A0%E5%A5%BD%22%20manual%20clickable%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-link%3E%E8%AF%B7%E7%82%B9%E5%87%BB%E6%88%91%3C%2Fot-link%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-title-tip%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
